import BoldLock from '@crehana/icons/BoldLock';
import CrehanaForBusiness from '@crehana/icons/logos/CrehanaForBusiness';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Container, colors } from '@crehana/ui';

const { white } = colors;

const Header = () => (
  <div className="bg-base-dark w-full">
    <Container className="flex items-center justify-between py-16">
      <a
        className="flex flex-col justify-center items-center"
        style={{ width: 'fit-content' }}
        href="/business/"
      >
        <CrehanaForBusiness color={white} secondaryColor={white} size={24} />
      </a>
      <div className="flex items-center" style={{ width: 'fit-content' }}>
        <BoldLock size={20} color={white} className="mr-8" />
        <p className="font-link text-white">Pago 100% seguro</p>
      </div>
    </Container>
  </div>
);

export default Header;
